module.exports = __webpack_public_path__ + "static/amazingdaddyvest-e18fcda3d6397ae0c12deaee504bc98e.jpeg";